/**
 * @description: 仓库数据
 */
import { request } from 'ice';
import { getLocale } from '@/locales/locale';
import { BASEDATASERVICE } from '@/const';
import { getSessionStorageDict, getSessionToJson } from '@/utils/getDict';

interface IState {
  fbaChannel: ChannelProps[];
}

export interface ChannelProps {
  name: string;
  nameEn: string;
  carrierCode: string;
  code: string;
  supplierCode: string;
  supplierShortName: string;
}

/**
 * 获取localStorage里面的字典
 * @param type 字典名字
 * @returns Array
 */

export default {
  state: {
    // 物流渠道
    fbaChannel: getSessionStorageDict('fbaChannelDict'),
    fbaSupplier: getSessionStorageDict('fbaSupplierDict'),

    // FBA卡车渠道
    fbaTruckChannel: getSessionStorageDict('fbaTruckChannelDict'),
    fbaTruckSupplier: getSessionStorageDict('fbTruckaSupplierDict'),
    urlConfigList: getSessionStorageDict('urlConfigList'),
    allWarehouseList: getSessionStorageDict('allWarehouse'),

    waveAnalyzeSwitch: getSessionToJson('waveAnalyzeSwitch'),
  },

  effects: (dispatch) => ({
    async fetchFBAChannel(req: object = {}) {
      if (!getSessionStorageDict('fbaChannelDict')?.length) {
        const res = await request({
          url: `${BASEDATASERVICE}/system/channel/getChannelByAttribute?attributeName=channel_type&attributeValue=FirstFBA`,
          method: 'POST',
        });

        const fbaChannel =
          res?.map((e: ChannelProps) => ({
            ...e,
            label: getLocale()?.includes('zh') ? e?.name : e?.nameEn,
            value: e?.code,
          })) || [];
        const fbaSupplier = (res || [])?.map((e: ChannelProps) => ({
          ...e,
          label: e?.supplierShortName,
          value: e?.supplierCode,
        }));
        window.sessionStorage.setItem('fbaChannelDict', JSON.stringify(fbaChannel));
        window.sessionStorage.setItem('fbaSupplierDict', JSON.stringify(fbaSupplier));
        dispatch.dict.update({
          fbaChannel,
          fbaSupplier,
        });
      }
    },
    async fetchFBATruckChannel(req: object = {}) {
      if (!getSessionStorageDict('fbaTruckChannelDict')?.length) {
        const res = await request({
          url: `${BASEDATASERVICE}/system/channel/getChannelByAttribute?attributeName=p-transport&attributeValue=FbaTruck`,
          method: 'POST',
        });

        const fbaTruckChannel =
          res?.map((e: ChannelProps) => ({
            ...e,
            label: getLocale()?.includes('zh') ? e?.name : e?.nameEn,
            value: e?.code,
          })) || [];
        const fbaTruckSupplier = (res || [])?.map((e: ChannelProps) => ({
          ...e,
          label: e?.supplierShortName,
          value: e?.supplierCode,
        }));
        window.sessionStorage.setItem('fbaTruckChannelDict', JSON.stringify(fbaTruckChannel));
        window.sessionStorage.setItem('fbaTruckSupplierDict', JSON.stringify(fbaTruckSupplier));
        dispatch.dict.update({
          fbaTruckChannel,
          fbaTruckSupplier,
        });
      }
    },
    async fetchUrlConfigList(req: object = {}) {
      const res = await request({
        url: '/giws-basic/system/osMenuConfig/page',
        method: 'POST',
        data: {
          data: {},
          pageObj: { pageSize: 1000, current: 1 },
        },
      });
      const urlConfigList: any = [];
      (res?.list || []).map((item) => {
        if (item.enable === 'Y') {
          urlConfigList.push(item);
        }
      });
      window.sessionStorage.setItem('urlConfigList', JSON.stringify(urlConfigList));
      dispatch.dict.update({
        urlConfigList,
      });
    },
    async fetchAllWarehouseList(req: object = {}) {
      const res = await request({
        url: `${BASEDATASERVICE}/rpc/warehouse/getWarehouseByRegional`,
        method: 'GET',
      });
      const allWarehouseList = dealTreeData(res || [], false) || [];
      window.sessionStorage.setItem('allWarehouseList', JSON.stringify(allWarehouseList));
      dispatch.dict.update({
        allWarehouseList,
      });
    },

    async newWaveAnalyzeSwitchMapApi() {
      const res = await request({
        url: 'outbound/giws/waveAnalyzePage/newWaveAnalyzeSwitchMap',
        method: 'GET',
      });
      window.sessionStorage.setItem('waveAnalyzeSwitch', JSON.stringify(res || {}));
      dispatch.dict.update({
        waveAnalyzeSwitch: res || {},
      });
    },
  }),

  reducers: {
    update(prevState: IState, payload: IState) {
      return { ...prevState, ...payload };
    },
  },
};

/**
 * 处理仓库树形数据
 * @param value
 * @returns TreeData[]
 */
const dealTreeData = (value, selectable = true, fromRdcId = '') => {
  if (!value?.length || value?.warehouses?.length) return [];
  return value?.map((e) => {
    const childrenCode = selectable ? `${e?.code}--` : '';
    return {
      ...e,
      label: `${childrenCode}${e?.name}`,
      value: e?.code,
      key: e?.code,
      selectable,
      fromRdcId,
      children: dealTreeData(e?.warehouses, true, e?.code),
    };
  });
};
